import { useEffect, useState } from "react";
import {
	calculationsFoldersListAPI,
	folderCalcListAPI
} from "../../../../../../services/api/calculator";
import { format_datetime_convert } from "../../../../../../helpers/tools";
import DarkCard from "../../../../../../components/card/DarkCard";
import styled from "styled-components";
import { Colors } from "../../../../../../components/theme";
import { useTranslation } from "react-i18next";
// import { ProjectContext } from "../../../../../../contexts/AppContext";
import { ElementStyle } from "../../../../../../layouts/styles";
import { FieldStyle } from "../../../../../../layouts/styles";
import {useNavigate} from "react-router-dom";
import RedHeader from "../../../../../../components/ui/RedBgTitleHeader";

const ListElement = styled.div`
	border-radius: 5px;
	padding: 8px 15px;
	margin: 15px 0px;
	background-color: ${Colors.lightBG};
`;

const TxtTitles = styled.p`
	font-size: 0.7em;
    text-transform: uppercase;
	width: 100%;
    padding: 0 0 3px 0;
    margin: 0;
    color: ${Colors.darkRed};
`;

const FolderList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const FolderItem = styled.div`
  display: inline-block;
  border-radius: 5px;
  padding: 8px 15px;
  background-color: ${props => props.bg || '#f5f5f5'};
  cursor: pointer;
  font-weight: bold;
  text-align: left;
  width: fit-content;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: #B41F23;
    color: #fff;
  }
`;

const SavedCalculations = () => {
	const { t } = useTranslation();
	const [calcList, setCalcList] = useState([]);
	const [foldersList, setFoldersList] = useState([]);
	const [selectedFolder, setSelectedFolder] = useState(null);


	useEffect(() => {
		const getFoldersListAPI = async () => {
			try {
				const response = await calculationsFoldersListAPI();
				console.log(response.data);
				setFoldersList(response.data.folders);
				setCalcList(response.data.calcs_list);
			} catch (e) {
				console.error(e);
				navigate('/network-error');
			}
		}
		getFoldersListAPI();
	}, []);

	useEffect(() => {
		const getCalculationsList = async () => {
			try {
				const response = await folderCalcListAPI({"folder_name": selectedFolder});
				const new_data = response.data.map(el => ({
					...el,
					created: format_datetime_convert(el.created),
					modify: format_datetime_convert(el.modify),
				}));
				setCalcList(new_data);
			} catch (e) {
				console.error(e);
				navigate('/network-error');
			}
		};
		if (selectedFolder) getCalculationsList();
	}, [selectedFolder]);

	const navigate = useNavigate()
	const handleClick = (pk) => {navigate("/sales/calculator/"+pk)}

	return (
		<>
			<DarkCard classNames='mb-3 row'>
				<p className="m-0 p-0 breadcrumbs">
					<span className="txt">{t("menu.sales",{ ns: 'menu' })}</span> &#9656;
					<span className="txt">{t("menu.saved_calculations",{ ns: 'menu' })}</span>
				</p>
			</DarkCard>

			<DarkCard classNames='mb-3 row'>
				<RedHeader title={t("calculator.folders_list_title")} />

				<FolderList>
					{foldersList.length > 0 && foldersList.map((item, key_id) => (
						<FolderItem key={key_id} onClick={() => setSelectedFolder(item)}>
						{item}
						</FolderItem>
					))}
				</FolderList>
			</DarkCard>

			<DarkCard classNames='mb-3 row'>
				<h1 className='mt-0 p-0'>{t("calculator.saved_list_title")}</h1>
				<h5 className='mt-0 p-0'>{t("calculator.selected_folder_title")}: {selectedFolder ? <b>{selectedFolder}</b> : t("common.data_filters.none_selected")}</h5>
				{calcList.length < 1
					? <p>{t("calculator.no_data")}</p>
					: calcList.map(el => (
							/*<ListElement key={el.pk}>
								<Link to={`/sales/calculator/${el.pk}`}>
									<b style={{ fontSize: "18px" }}>{el.name}</b>&nbsp;-&nbsp;
									{t("calculator.created_date_time")} {el.created}&nbsp;-&nbsp;
									{t("calculator.modified_date_time")} {el.modify}
								</Link>
							</ListElement>*/
							<ElementStyle className={"d-flex flex-column"} key={el.pk}>
								<div className="d-flex flex-row flex-wrap flex-md-nowrap py-1" style={{width: '95%'}}>
									<FieldStyle width="13%" className="p-1">
										<div>
											<TxtTitles>{t("calculator.id_title")}</TxtTitles>
											<a onClick={() =>{handleClick(el.pk)}}><b>C{el.pk}</b></a>
										</div>
									</FieldStyle>

									<FieldStyle className="p-1">
										<div>
											<TxtTitles>{t("calculator.name_title")}</TxtTitles>
											<a onClick={() =>{handleClick(el.pk)}}><b>{el.name}</b></a>
										</div>
									</FieldStyle>

									<FieldStyle className="p-1">
										<div>
											<TxtTitles>{t("calculator.created_date_time")}</TxtTitles>
											{el.created}
										</div>
									</FieldStyle>

									<FieldStyle className="p-1">
										<div>
											<TxtTitles>{t("calculator.modified_date_time")}</TxtTitles>
											{el.modify}
										</div>
									</FieldStyle>
								</div>
							</ElementStyle>
					 ))
				}
			</DarkCard>
		</>
	);
};

export default SavedCalculations;
